import {flattenDeep} from "lodash";
import {interpolateRgb} from "./utils";


const mixColor = v => {
  return interpolateRgb(v * 100).match(/\d+/g).map(x => parseInt(x));
}

export const zipVizData = (geometries, attributes) => {
  // console.log(geometries, attributes);
  const lines = flattenDeep(
      geometries.map((geom, i) => {
        const color = mixColor(attributes[i].volumeToCapacity);
        return geom.lines.map(line => ({
          coordinates: line.coordinates,
          color
        }));
      })
  );

  const points = flattenDeep(
      geometries.map((geom, i) => {
        const color = mixColor(attributes[i].volumeToCapacity);
        // console.log(geom.points.length);
        return geom.points.map((point, p) => ({
          coordinates: point.coordinates,
          color,
          arrayPos: (p+1) / geom.points.length,
          speed: attributes[i].speed,
          contourIndex: i,
          volume: attributes[i].volume
        }));
      })
  );
  // console.log(points); 
  return {
    scatterplot: points,
    paths: lines
  };
};



// WEBPACK FOOTER //
// ./src/viz-data.js